/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetClearanceCaseDropdownFiltersResponseJson } from './get-clearance-case-dropdown-filters-response-json';
import { DefaultGetResult } from '../results/default-get-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CaseManagerDropdownDto } from '../models/case-manager-dropdown-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetClearanceCaseDropdownFiltersResponse extends ResponseWithErrorGeneric<GetClearanceCaseDropdownFiltersResponseJson, DefaultGetResult> implements IResponseWithErrorGeneric<DefaultGetResult> {
  public caseManagers: CaseManagerDropdownDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetClearanceCaseDropdownFiltersResponse>) {
    super(response, DefaultGetResult.Error);
    if (this.result !== DefaultGetResult.Success) {
      return;
    }

    this.caseManagers = this.body.caseManagers;
  }
  //</custom-body>
}
